export enum PaymentEnum{
    Debit = 1,
    Credit = 2,
    Tip = 3,
}